import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import logo from "../../assets/images/Logo.png"
import ConfigUrl from "../../config"
import secureLocalStorage from "react-secure-storage"
import axios from "axios"
import { notification } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import { FaBackward } from "react-icons/fa"

const ForgetPasswordPage = props => {
  //meta title
  document.title = "Forget Password"

  const navigate = useNavigate()

  const [Email, setEmail] = useState("")

  const [Loading, setLoading] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    if (Email !== "") {
      setLoading(true)
      secureLocalStorage.setItem("UserEmail", Email)

      try {
        const response = await axios.post(
          `${ConfigUrl.apiurl}/auth/user/send-email`,
          {
            email: Email,
          }
        )

        if (response?.data?.success === true) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <SiTicktick className="text-success" size={22} />
                </div>
                <div>OTP Sent Successfully</div>
              </div>
            ),
            description: response?.data?.message,
          })
          secureLocalStorage.setItem("tempOTP", response?.data?.token)
          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}verify-otp`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: response?.data?.message,
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e.response?.data?.message,
        })
      }
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center">
            <Col xl={7}></Col>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={6}>
                      <div className="text-primary p-4">
                        <h5 className="text-dark">Welcome Back !</h5>
                        <p className="mb-0 text-dark">Reset Password</p>
                      </div>
                    </Col>
                    <Col className="col-6 p-2 d-flex justify-content-end pe-5">
                      <div className=" profile-user-wid ">
                        <span className="avatar-title rounded-4 px-1 bg-light">
                          <img src={logo} alt="" className="w-100" />
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0 bg-light">
                  <div>
                    <Link to="/"></Link>
                  </div>
                  <div className="p-2">
                    {/* {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null} */}

                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="my-3">
                        <Label className="form-label">
                          Email <span className="text-danger">*</span>{" "}
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={e => setEmail(e.target.value)}
                          value={Email || ""}
                          required
                        />
                      </div>
                      <Row className="mb-3 align-items-end">
                        <Col className="col-xl-6">
                          <h6>
                            <Link
                              to={`${ConfigUrl.appurl}login`}
                              className="font-weight-medium text-secondary"
                            >
                              <FaBackward /> Go back to Login
                            </Link>{" "}
                          </h6>
                        </Col>
                        <Col className="col-xl-6 text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
